import React from "react";
import { PageHeader } from "./../Components";
import setNavigation from "actions/set_navigation";
import create_card_applications from "actions/create_card_applications";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CheckCircle from "react-icons/lib/fa/check-circle";
import { Col } from "Components";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import InputMask from "react-input-mask";
import { bcmod } from "./functions";

const format = (value, pattern) => {
  var i = 0,
    v = value.toString();
  return pattern.replace(/#/g, _ => v[i++]);
};

class Contact extends React.PureComponent {
  state = {
    branch_code: 10
  };
  render = () => (
    <div>
      <NotificationContainer />
      <PageHeader headerClass={"contact-us"} pageName="Uban Sorgulama" />
      {/* <JSONTree data={this.state}/> */}
      <div className="container mt80 mb80 contact_us_page">
        <p className="title">Uban Sorgulama</p>
        <p className="inner_content">
          UBAN Sorgulama aracı kullanarak UBAN numaranızı kolayca sorgulayabilir
          ve işlemlerinizde kullanabilirsiniz.
        </p>
        <div className="row narrow mt40">
          <Col l={6} m={6}>
            <label> Hesap Numarası</label>
            <InputMask
              mask="99-999-9999999999"
              value={this.state.account_number}
              onChange={e => {
                this.setState({
                  account_number: e.target.value,
                  calculated_uban: null
                });
              }}
              placeholder="____ ____ _______"
            />
          </Col>
          <Col l={6} m={6}>
            <label> Şube Kodu</label>
            <select
              className="select_branch"
              value={this.state.branch_code}
              onChange={e => {
                this.setState({
                  branch_code: e.target.value
                });
              }}
            >
              <option>10</option>
              <option>11 </option>
              <option>12</option>
              <option>14</option>
              <option>20</option>
              <option>30</option>
              <option>40</option>
            </select>
          </Col>
        </div>
        {this.state.calculated_uban ? (
          <div className="row">
            <div className="success_message">
              <CheckCircle className="icon" /> UBAN Numarası :{" "}
              {format(
                this.state.calculated_uban,
                "#### #### #### #### #### #### ####"
              )}
            </div>
          </div>
        ) : null}
        <div className="row">
          <button
            onClick={() => {
              try {
                let { account_number, branch_code } = this.state;
                account_number = account_number
                  .split(" ")
                  .join("")
                  .split("-")
                  .join("");

                let bankakodu = 131;
                let rezerve = 0;
                let tam = 0;
                let ulke = 122900;
                let ulke3 = 1229;
                let subetam1 = 91;
                let subetam2 = branch_code;
                let raw = `${bankakodu}${rezerve}${subetam1}${subetam2}${tam}${account_number}${ulke}`;
                let mod = Math.abs(bcmod(raw, 97) - 98);
                let kontrolkod = mod;
                if (mod < 10) {
                  kontrolkod = `0${kontrolkod}`;
                }
                let ubann = `${bankakodu}${rezerve}$subetam1$subetam2$subekodu${tam}${account_number}${ulke3}$kontrolkod`;
                let uban = bcmod(ubann, 97);
                if (account_number.length === 15) {
                  uban = `CT${kontrolkod}${bankakodu}${rezerve}${subetam1}${subetam2}${tam}${account_number}`;
                  this.setState({
                    calculated_uban: uban
                  });
                } else {
                }
              } catch (err) {
                NotificationManager.error(
                  "Lütfen doğru bilgiler giriniz",
                  "Başarısız"
                );
              }
            }}
            disabled={!this.state.account_number && !this.state.branch_code}
            style={{
              position: "relative",
              left: "4%"
            }}
            className="submit-btn"
          >
            HESAPLA
          </button>
        </div>

        <div className="row mt50">
          <Col l={12} m={12}>
            <label> UBAN Numarası</label>
            <InputMask
              value={this.state.uban_number}
              onChange={e => {
                this.setState({
                  uban_number: e.target.value,
                  err_uban: false,
                  correct_uban: false
                });
              }}
              mask="CT99-9999-9999-9999-9999-9999-9999"
              placeholder="CT__-____-____-____-____-____-____"
              //   placeholder="Telefon Numaranız"
            />
          </Col>
        </div>
        {this.state.correct_uban ? (
          <div className="row">
            <div className="success_message">
              <CheckCircle className="icon" /> UBAN Numarası Doğrudur.
            </div>
          </div>
        ) : null}
        {this.state.err_uban ? (
          <div className="row">
            <div className="err_message">
              <CheckCircle className="icon" /> UBAN Numarası eksik veya
              NOVABANK'a ait geçerli bir numara değildir.
            </div>
          </div>
        ) : null}
        <div className="row">
          <button
            onClick={() => {
              let parsedUban = this.state.uban_number
                .split("_")
                .join("")
                .split("-")
                .join("");
              let err_uban = false;

              let kod = parsedUban.substr(2, 2);
              let uban1 = parsedUban.substr(4, 3);
              let uban2 = parsedUban.substr(4, 24);
              let ubanharf = parsedUban.substr(0, 2);
              let ubansube = parsedUban.substr(10, 2);
              let ct = 1229;
              // let novauban = parsedUban.toUpperCase();
              ubanharf = ubanharf.toUpperCase();
              let raw = 0;

              if (
                ubansube === "10" ||
                ubansube === "11" ||
                ubansube === "12" ||
                ubansube === "14" ||
                ubansube === "20" ||
                ubansube === "30" ||
                ubansube === "40"
              ) {
              } else {
                err_uban = true;
              }
              if (
                ubanharf === "CT" &&
                parsedUban.length === 28 &&
                uban1 === "131"
              ) {
              } else {
                err_uban = true;
              }
              raw = `${uban2}${ct}${kod}`;
              let mod = bcmod(raw, 97);
              if (parseInt(mod) !== 1) {
                err_uban = true;
              }
              this.setState({
                err_uban,
                correct_uban: !err_uban
              });
            }}
            disabled={!this.state.uban_number}
            style={{
              position: "relative",
              left: "4%"
            }}
            className="submit-btn"
          >
            DOĞRULA
          </button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  navigation: state.navigation,
  alert: state.card_applications ? state.card_applications.alert : [],

  screen: state.screen
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNavigation,
      create_card_applications
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);
